import { render, staticRenderFns } from "./PurchaseBased.vue?vue&type=template&id=7c43e736&scoped=true"
import script from "./PurchaseBased.vue?vue&type=script&lang=js"
export * from "./PurchaseBased.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c43e736",
  null
  
)

export default component.exports